// extracted by mini-css-extract-plugin
export default {"dailyTip":"dailytip_dailyTip__n4ecF"};